import { v4 as uuid } from "uuid";
import { useContext, useState } from "react";
import { useFormContext } from "react-hook-form";
import Card from "../../../components/card/card";
import { sendOtpForEmail } from "../../../../../actions";
import { useAppDispatch } from "../../../../../store/hooks";
import { addNotification } from "../../../../../store/slices/ui-slice";
import { USER_APPOINTMENT_ACTIONS, UserAppointmentContext } from "../../../context/user-appointment-context";
import TextInputFormField from "../../../../../components/form-fields/text-input-field/text-input-form-field";

const EmailForm = () => {
  const {
    state: { activeStep },
    userDispatcher,
  } = useContext(UserAppointmentContext);
  const {
    control,
    watch,
    formState: { isValid },
  } = useFormContext();
  const email = watch("email");
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);

  const sendEmail = async () => {
    setLoading(true);
    try {
      await sendOtpForEmail({ email });
      userDispatcher({
        type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
        payload: activeStep + 1,
      });
    } catch (err: any) {
      dispatch(
        addNotification({
          id: uuid(),
          type: "error",
          message: err.message || "An unexpected error occurred.",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      title={"Email Page"}
      description={
        "Please enter your email, preferably the one provided to chasing tails. This will help us retrieve your information so you won't have to enter it again."
      }
      btnTitle={"Continue"}
      onHandleClick={sendEmail}
      progress={activeStep * 5}
      disabledConfirmBtn={!isValid}
      isLoadingConfirmBtn={loading}
    >
      <TextInputFormField
        label="Email"
        name={"email"}
        control={control}
        placeholder="example@mail.com"
      />
    </Card>
  );
};

export default EmailForm;
